import React from 'react';
import { useState,useEffect } from 'react';
import NavCard from '../NavCard';
import '../../styles/NavCard.css'

const Navoptionsredmiphones = ({redmiPhones}) => {
    console.log("miphones",redmiPhones);
    
    return (
        <>         
         <div className="navOptions">
         {  redmiPhones.map((item,index)=>{  
             console.log("111111111",item)
             return(
          <NavCard name={item['name']} price={item['price']} image={item['image']} key={item['image']} index={index}></NavCard> 
             )
              })
         }

         </div>  

        </>
    )
}

export default Navoptionsredmiphones;
